const SHOP_DOMAIN_REGEX = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/

const STRIPPED_QUERY_KEYS = [
    'shop',
    'host',
    'embedded',
    'hmac',
    'id_token',
    'session',
    'timestamp',
    'locale'
]

export const isValidShopDomain = shop => typeof shop === 'string' && SHOP_DOMAIN_REGEX.test(shop)

export const buildAdminAppUrl = ({ shop, apiKey, path, query }) => {
    const params = Object.keys(query || {})
        .filter(key => !STRIPPED_QUERY_KEYS.includes(key))
        .reduce((acc, key) => {
            const values = Array.isArray(query[key]) ? query[key] : [query[key]]

            values.forEach(value => {
                if (value === null || value === undefined) {
                    acc.push(encodeURIComponent(key))
                } else {
                    acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                }
            })

            return acc
        }, [])
        .join('&')

    const base = `https://${shop}/admin/apps/${apiKey}${path === '/' ? '' : path || ''}`

    return params ? `${base}?${params}` : base
}



// WEBPACK FOOTER //
// ./src/helpers/admin-url.js